import { useState } from 'react';
import { ApprovalContext } from '../context/approvalContext';
import { withApproval } from '../hoc/withApproval';
import { ApprovalModal } from './modal/ApprovalModal';
// @ts-ignore dependency missing types
import FeedbackLoader from 'feedback-loader';
import enviro from 'enviro';
import { ApprovalOperation } from 'ui-product-approvals-common';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ApprovalDataErrorMessage } from './sidebar/ApprovalDataErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LazyApprovalEditPanel = Loadable({
  loader: () => import( /* webpackChunkName: "ApprovalEditPanel" */'./editPanel/ApprovalEditPanel').then(mod => ({
    default: mod.ApprovalEditPanel
  })),
  LoadingComponent: () => null,
  ErrorComponent: ({
    onClose
  }) => /*#__PURE__*/_jsxs(ModalPanel, {
    onCloseComplete: onClose,
    onBackdropClick: onClose,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })
    }), /*#__PURE__*/_jsx(ApprovalDataErrorMessage, {})]
  })
});
const ApprovalProvider = ({
  children,
  approval,
  modalAlertContent,
  modalAlertOnRequestSuccess
}) => {
  const showModal = approval.meta.showModal;
  const currentOperation = approval.meta.currentOperation;
  const showApprovalEditPanel = approval.meta.showApprovalEditPanel;

  // Feedback survey for approvers and requesters.
  const SURVEY_ID_APPROVER = enviro.isQa() ? 253 : 802;
  const SURVEY_ID_REQUESTER = enviro.isQa() ? 252 : 801;
  const [showSurvey, setShowSurvey] = useState(false);
  const showFeedbackSurvey = () => {
    setShowSurvey(true);
  };
  const getSurveyID = () => {
    if (currentOperation === ApprovalOperation.REQUEST) {
      return SURVEY_ID_REQUESTER;
    } else if (currentOperation === ApprovalOperation.APPROVE) {
      return SURVEY_ID_APPROVER;
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(ApprovalContext.Provider, {
    value: approval,
    children: [children, showModal && /*#__PURE__*/_jsx(ApprovalModal, {
      onClose: () => {
        approval.meta.setShowModal(false);
        approval.meta.setCurrentOperation(null);
      },
      alertContent: modalAlertContent,
      onRequestSuccess: modalAlertOnRequestSuccess,
      showFeedbackSurvey: showFeedbackSurvey
    }), showApprovalEditPanel && /*#__PURE__*/_jsx(LazyApprovalEditPanel, {
      approvalAction: approval.meta.approvalAction,
      approvalType: approval.meta.approvalType,
      onClose: () => {
        approval.meta.setShowApprovalEditPanel(false);
      }
    }), showSurvey && getSurveyID() ? /*#__PURE__*/_jsx(FeedbackLoader, {
      onClientLoad: feedbackClient => {
        feedbackClient.loadSurvey('CSAT', getSurveyID());
      }
    }) : '']
  });
};

/**
 * @remarks
 * Consumer styling requirement: add the import below to the consuming app's
 * `project.sass`. This mounts the approval modal's hubspot-prosemirror note
 * editor, which renders unstyled without it.
 *
 * @example
 * ```sass
 * @import hubspot-prosemirror/sass/project
 * ```
 */
const ApprovalProviderWithApproval = withApproval(ApprovalProvider);
export { ApprovalProviderWithApproval as ApprovalProvider };
/*
 * TestUIApprovalProvider should only be used in our Test UI.
 */
export { ApprovalProvider as TestUIApprovalProvider };